import { z } from "zod";

export const putGroupSchema = z.object({
  name: z.string(),
}).strip();
export const patchGroupSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
}).strip();
export type putGroupType = z.infer<typeof putGroupSchema>;
export type patchGroupType = z.infer<typeof patchGroupSchema>;